import { render, staticRenderFns } from "./info2.vue?vue&type=template&id=c31730a6&scoped=true"
import script from "./info2.vue?vue&type=script&lang=js"
export * from "./info2.vue?vue&type=script&lang=js"
import style0 from "./info2.vue?vue&type=style&index=0&id=c31730a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c31730a6",
  null
  
)

export default component.exports